var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Route } from "react-router-dom";
import { Button, Dimmer, Form, Grid, Loader } from "semantic-ui-react";
import { RnaCatalogType } from "../../admin/EditOrderKit";
import { CatalogMode } from "../../RequestHelpers";
import { buildEditFormStateHandlerForComponent } from "../FormState";
import { CART_PRICE_PATH } from "../rna-fish/EditKitForm";
import { LoadWrapper } from "../rna-fish/LoadWrapper";
import { addToCartHandlerBuilder } from "../rna-fish/NewRnaFishKitPage";
import ChromogenKitForm from "./ChromogenKitForm";
import { RelevantCatalogType } from "./RnaCatalog";
import { RnaCatalogLoader } from "./RnaCatalogLoader";
var NewChromogenKitPage = /** @class */ (function (_super) {
    __extends(NewChromogenKitPage, _super);
    function NewChromogenKitPage(props) {
        return _super.call(this, props) || this;
    }
    NewChromogenKitPage.prototype.render = function () {
        var rendererFn = function (catalog) { return React.createElement(React.Fragment, null,
            React.createElement(NewChromogenKitContent, { catalog: catalog })); };
        return React.createElement(React.Fragment, null,
            React.createElement(LoadWrapper, { loader: new RnaCatalogLoader(CatalogMode.Consumer, RelevantCatalogType.Initial, RnaCatalogType.RnaCish), render: rendererFn }));
    };
    return NewChromogenKitPage;
}(React.PureComponent));
export default NewChromogenKitPage;
var NewChromogenKitContent = /** @class */ (function (_super) {
    __extends(NewChromogenKitContent, _super);
    function NewChromogenKitContent(props) {
        var _this = _super.call(this, props) || this;
        _this.onAddToCart = addToCartHandlerBuilder(function (callback) {
            _this.setState({
                loading: true
            }, callback);
        }, function () { return JSON.stringify(ChromogenKitForm.serializeChromogenKit(_this.state.formState)); }, function (history) {
            _this.setFormState(function () { return ({
                errors: [],
            }); }, function () {
                _this.setState({
                    loading: false,
                }, function () {
                    history.push('/cart');
                });
            });
        }, function (errors) {
            _this.setFormState(function () { return ({
                errors: errors.errors,
            }); }, function () {
                _this.setState({
                    loading: false,
                });
            });
        });
        _this.setFormState = buildEditFormStateHandlerForComponent('formState', _this);
        _this.addToCartButton = function (props) {
            var onClick = function () {
                _this.onAddToCart(props.history);
            };
            return React.createElement(Button, { disabled: _this.disableAddToCartButton(), className: 'cish-button', icon: 'cart plus', label: "Add To Cart", labelPosition: "left", onClick: onClick, positive: true });
        };
        _this.disableAddToCartButton = function () {
            var formState = _this.state.formState;
            return formState.protocolType == null || formState.scale == null || formState.chromogen == null;
        };
        _this.state = {
            loading: false,
            formState: defaultChromogenKitFormState()
        };
        return _this;
    }
    NewChromogenKitContent.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { id: "non-header-portion", className: 'enzymatic-ish-form', as: Form, error: this.state.formState.errors.length > 0 },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            React.createElement(ChromogenKitForm, { kitPriceUrlPath: CART_PRICE_PATH, catalog: this.props.catalog, formState: this.state.formState, setFormState: this.setFormState, loadPriceOnMount: false }),
            React.createElement(Grid, { columns: 1, textAlign: "right" },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3 }),
                    React.createElement(Grid.Column, { width: 12 },
                        React.createElement(Route, { render: this.addToCartButton })))));
    };
    return NewChromogenKitContent;
}(React.PureComponent));
export var defaultChromogenKitFormState = function () {
    return {
        protocolType: undefined,
        scale: undefined,
        chromogen: undefined,
        errors: [],
        price: undefined,
        priceLoading: false,
        comment: ""
    };
};
//# sourceMappingURL=NewChromogenKitPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-pro/NewChromogenKitPage.js
// module id = 327
// module chunks = 0